// src/sections/AvisTroisPartenaires.jsx
import React from "react";

const REVIEWS = [
  {
    name: "Sophie B.",
    meta: "Commerçante à Claix",
    text:
      "PACTE m’a permis de fidéliser une nouvelle clientèle locale. Grâce à l’application, mes offres sont vues par beaucoup plus de Claixois.",
    avatar: "https://pacte-claix.fr/assets/images/PPCommerce1.jpg",
  },
  {
    name: "Julien M.",
    meta: "Boulanger à Pont-Rouge",
    text:
      "Depuis que j’ai rejoint PACTE, je vois clairement la différence : plus de passages en boutique et des clients réguliers grâce au système de tampons.",
    avatar: "https://pacte-claix.fr/assets/images/PPCommerce2.jpg",
  },
  {
    name: "Claire D.",
    meta: "Responsable d’une boutique de mode",
    text:
      "Une super visibilité pour ma boutique, et une belle mise en avant lors des événements locaux. L’équipe est très à l’écoute des commerçants.",
    avatar: "https://pacte-claix.fr/assets/images/PPCommerce3.jpg",
  },
];

function Card({ children }) {
  return (
    <div className="h-full rounded-[24px] bg-[#FAFAFA] shadow-[0_6px_18px_rgba(0,0,0,0.06)] p-5 sm:p-6">
      {children}
    </div>
  );
}

export default function AvisTroisPartenaires() {
  return (
    <section className="mx-auto max-w-[1189px] px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
      {/* Titre + sous-titre */}
      <div className="text-center max-w-4xl mx-auto">
        <h2 className="font-asap font-semibold tracking-tight text-neutral-900 text-[34px] sm:text-[46px] leading-[1.1]">
          Ils ont rejoint PACTE&nbsp;!
        </h2>
        <p className="mt-4 text-[15px] sm:text-[18px] text-neutral-600 leading-relaxed">
          Les commerçants partenaires témoignent : plus de visibilité, plus de clients
          et une vraie dynamique locale créée grâce à PACTE.
        </p>
      </div>

      {/* 3 cartes fixes + fades latéraux */}
      <div className="relative mt-10 sm:mt-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
          {REVIEWS.map((r, idx) => (
            <Card key={idx}>
              <div className="flex items-start gap-3">
                <img
                  src={r.avatar}
                  alt={r.name}
                  className="h-12 w-12 rounded-full object-cover shrink-0"
                />
                <div>
                  <div className="font-asap font-semibold text-neutral-900 text-[18px]">
                    {r.name}
                  </div>
                  <div className="text-xs text-neutral-500">{r.meta}</div>
                </div>
              </div>
              <p className="mt-4 text-[17px] leading-7 text-neutral-800">{r.text}</p>
            </Card>
          ))}
        </div>

        {/* Fades */}
        <div
          aria-hidden
          className="pointer-events-none absolute inset-y-0 -left-6 w-36 sm:w-16 bg-gradient-to-r from-white to-transparent"
        />
        <div
          aria-hidden
          className="pointer-events-none absolute inset-y-0 -right-6 w-36 sm:w-16 bg-gradient-to-l from-white to-transparent"
        />
      </div>
    </section>
  );
}